<div style="position: relative; display: flex" class="qpoint-button">
  <div class="spinner-wrapper" *ngIf="loading && !icon">
      <qpoint-loading-spinner style="min-width: 15px" [inline]="true"
                              *ngIf="loading"></qpoint-loading-spinner>
  </div>
  <kendo-splitbutton
    [ngClass]="classes"
    (buttonClick)="onClick($event)"
    [data]="popUpItems"
    [disabled]="isDisabled"
    (open)="onOpen($event)"
    (close)="onClose($event)"
    #kendoSplitButton
  >

    <div style="position: relative; display: flex; align-items: center; justify-content: center">
      <ng-container *ngIf="icon">
        <div class="d-flex">
        <qpoint-icon [icon]="icon" [iconType]="iconType" *ngIf="!loading"></qpoint-icon>
        <qpoint-loading-spinner style="min-width: 15px" [inline]="true"
                                *ngIf="loading"></qpoint-loading-spinner>
        </div>
      </ng-container>
      <span style="white-space: nowrap">{{ text }}</span>
    </div>
  </kendo-splitbutton>

</div>
